import React from 'react';

import { useModal } from '@vlabs/uikit';
// ponytail: осознанный импорт роутов приложения — компонент используется только в point3 (GUI-3947)
import { routes } from '@vlapps/point3/src/app/routes';

import type { LinkProps } from '@vlabs/monokit/shared/ui/link';
import { Link } from '@vlabs/monokit/shared/ui/link';

import { StreamLogsContent } from './StreamLogsContent';
import { useStreamLogsTranslation } from '../i18n';
import type { StreamLogsProps } from '../types';
import st from './StreamLogsLink.module.sass';

interface StreamLogsLinkProps extends StreamLogsProps, Omit<LinkProps, 'onClick' | 'to'> {}

function StreamLogsLink({
  streamId,
  ...props
}: StreamLogsLinkProps): React.JSX.Element {
  const { t } = useStreamLogsTranslation();
  const modal = useModal({ size: 'large', contentClassName: st.LogsModal });

  const openLogs = (event: React.MouseEvent<HTMLAnchorElement>) => {
    // href — только фолбэк; реальное действие — модалка, навигации быть не должно
    event.preventDefault();
    modal.open();
  };

  return (
    <React.Fragment>
      {modal.wrap(
        <StreamLogsContent streamId={streamId} />,
      )}

      <Link
        onClick={openLogs}
        surface="default"
        to={routes.sources.list}
        type="secondary"
        {...props}
      >
        {t('title')}
      </Link>
    </React.Fragment>
  );
}

export { StreamLogsLink };
